import { render } from "./Pets.vue?vue&type=template&id=ced6338e&scoped=true"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"

import "./Pets.vue?vue&type=style&index=0&id=ced6338e&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced6338e"]])

export default __exports__